import { css } from '@microsoft/fast-element';
export const foundationDialogStyles = css `
  :host {
    --dialog-min-width: 358px;
    --notification-details-min-height: 40px;
  }

  .close-icon {
    position: absolute;
    right: calc(var(--design-unit) * 2px);
    top: calc(var(--design-unit) * 2px);
    cursor: pointer;
  }

  .close-icon svg {
    border-radius: calc(var(--control-corner-radius) * 1px);
    padding: calc(var(--design-unit) * 2px);
  }

  dialog {
    background-color: var(--dialog-background, var(--fill-color));
    padding: calc(var(--design-unit) * 2px) calc(var(--design-unit) * 4px)
      calc(var(--design-unit) * 4px);
    overflow: inherit;
  }

  :host([position='right']) dialog .content-wrapper,
  :host([position='left']) dialog .content-wrapper,
  :host([position='left']) dialog,
  :host([position='right']) dialog {
    height: 100%;
  }

  :host([position='left']) dialog {
    margin-left: 0;
  }

  :host([position='right']) dialog {
    margin-right: 0;
  }

  ::slotted(zero-divider) {
    width: 100%;
  }

  .title {
    margin-top: calc(var(--design-unit) * 2px);
    font-size: 14px;
  }

  .details {
    font-size: 12px;
    overflow: hidden;
    min-height: var(--notification-details-min-height);
  }
`;
